export const PLAYER_SLICE_KEY = 'player' as const;
